import React from "react";

/**
 * @component SunIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <SunIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SunIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SunIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M11 0a1 1 0 011 1v1.818a1 1 0 11-2 0V1a1 1 0 011-1z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 11a6 6 0 1112 0 6 6 0 01-12 0zm6-4a4 4 0 100 8 4 4 0 000-8z"
      />
      <path d="M12 19.182a1 1 0 10-2 0V21a1 1 0 102 0v-1.818zM3.22 3.22a1 1 0 011.414 0l1.291 1.291a1 1 0 11-1.414 1.414l-1.29-1.29a1 1 0 010-1.415zM17.489 16.075a1 1 0 00-1.414 1.414l1.29 1.29a1 1 0 001.415-1.413l-1.291-1.291zM0 11a1 1 0 011-1h1.818a1 1 0 110 2H1a1 1 0 01-1-1zM19.182 10a1 1 0 100 2H21a1 1 0 100-2h-1.818zM5.925 16.075a1 1 0 010 1.414l-1.29 1.29a1 1 0 01-1.415-1.413l1.291-1.291a1 1 0 011.414 0zM18.78 4.634a1 1 0 00-1.414-1.414l-1.291 1.291a1 1 0 001.414 1.414l1.29-1.29z" />
    </svg>
  )
);
SunIcon.displayName = "SunIcon";
export default SunIcon;
